import { ApolloError, QueryResult, gql, useLazyQuery } from '@apollo/client'
import { optionalEnrollmentId } from '@utils/optionalEnrollmentId'
import { ILesson } from '@dtos/Course'

const GET_NEXT_AVAILABLE_LESSON_DATA = gql`
  query NextAvailableLessonData($currentLessonId: ID!, $enrollmentId: ID) {
    nextAvailableLesson(
      currentLessonId: $currentLessonId
      enrollmentId: $enrollmentId
    ) {
      id
      title
      courseContentId
      releaseAt
      releaseAfter
      lockAt
      lockAfter
      createdAt
      description
      activity {
        id
        examQuestionsCount
      }
      media {
        id
        type
        duration
        hostKey
        host
        fileExt
        text
        organizationUuid
      }
      coverImage {
        cdnFileUrl
      }
      extraMediaReleases {
        mediaId
        releaseAt
        releaseAfter
        lockAt
        lockAfter
      }
      extraMedias {
        id
        title
        type
        duration
        fileExt
        text
        hostKey
        host
        organizationUuid
        createdAt
      }
    }
  }
`

export const useGetNextAvailableLessonData = (
  currentLessonId: number,
  /** Ausente na visão do produtor: não existe matrícula. */
  enrollmentId?: number | string | null,
) => {
  const [getNextAvailableLessonData, { loading, error }] = useLazyQuery(
    GET_NEXT_AVAILABLE_LESSON_DATA,
    {
      variables: {
        currentLessonId,
        enrollmentId: optionalEnrollmentId(enrollmentId),
      },
    },
  )

  return { getNextAvailableLessonData, loading, error } as {
    getNextAvailableLessonData: (
      currentLessonId: number,
      enrollmentId?: number | string | null,
    ) => Promise<QueryResult<{ nextAvailableLesson: ILesson }>>
    loading: boolean
    error: ApolloError
  }
}
